import { IPaginatedResponse, IResponse } from '../../../model';
import ServiceBase from '../../../servicebase';
import { IMoneda } from '../model/IMoneda';

export default class MonedaService extends ServiceBase {
  getEdit = (data:{ id?: number }) : Promise<IResponse<IMoneda>> => 
    this.GetFetch<IResponse<IMoneda>>('entity/moneda/edit', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, codigo?: string, nombre?: string, activo?: boolean }) : Promise<IPaginatedResponse<IMoneda>> => 
    this.GetFetch<IPaginatedResponse<IMoneda>>('entity/moneda/find', data);

  /*
  all = () : Promise<IResponse<IMoneda[]>> => 
    Common.indexedDB.StoreControl.apiget(Stores.Monedas, () => this.GetFetch<IResponse<IMoneda[]>>('entity/moneda/all', {}));
  */
    
  upsert = (data:IMoneda) : Promise<IResponse<IMoneda>> => 
    this.PostFetch<IResponse<IMoneda>>('entity/moneda', data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/moneda', data);  

  cotizaciones = (data: { idmoneda?: number, desde?: string, origen?: number }) : Promise<IResponse<any>> => 
    this.GetFetch<IResponse<any>>('entity/moneda/cotizaciones', data);
}